module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZBAMAAAA2x5hQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTCkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKZy2rHEAAAAIdFJOUwCdAmyA2wwDccsMRgAAAAlwSFlzAAAASAAAAEgARslrPgAAAIdJREFUGNNF0KERwzAMBdAfk9BckWG9QUBAYWE3aGBAF8gIYhq7tvwlGfhOfidb/vjt8HVc+IgXi77x0o1V1R1NxUmeKJVY9dF3ohEcJxFJRCfD5mR4Bg1MAtZTv1H0C1WyGn1bktyJ/a2Ydo4RX7ExHDkhkYcTF28wjFzKyCUzaz2zzLMc1x/qmivFpEOO4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/user/close.png
// module id = 74
// module chunks = 0